import { createContext, useContext, ReactNode } from 'react';
import { QueuedToast } from './notifications';

export interface ToastContextProps {
  queue: React.ReactNode[];
  dispatch: (toast: QueuedToast) => void;
  next: () => void;
}

// The default props are only exposed if a wrapping <Notifications/>
// is missing from the tree
export const defaultToastContext: ToastContextProps = {
  queue: [],
  dispatch: () => {
    throw new Error(
      'You are using <Toast/> without a <Notifications/> wrapper.'
    );
  },
  next: () => {
    throw new Error(
      'You are using <Toast/> without a <Notifications/> wrapper.'
    );
  }
};

export const ToastContext = createContext(defaultToastContext);

// convenience hook that saves you from having to import the ToastContext
// if you want to dispatch toasts manually
export const useToast = (): ToastContextProps => {
  return useContext(ToastContext);
};
